import styled from 'styled-components';
/*
 * IE specific browser support messaging
 */

export var StyledBrowserSupport = /*#__PURE__*/styled.div.withConfig({
  displayName: "BrowserSupportstyled__StyledBrowserSupport",
  componentId: "sc-1b3cr6k-0"
})(["display:", ";@media screen and (min-width:0\0){display:block;position:relative;z-index:3;}"], function (_ref) {
  var isDisabled = _ref.isDisabled;
  return isDisabled ? 'block' : 'none';
});